import React, {useEffect, useState} from 'react'
import { FormattedMessage } from 'react-intl.macro'
import { Spin, Button, Modal } from 'antd'
import { connectModal } from 'redux-modal'
import { SessionStorage } from "src/utils";
import { LOCAL_STORAGE_KEY } from 'src/constants'
import { redirectPage } from 'src/hooks/common'
import { queryStringExtensions } from 'src/extensions'
import { selectSearchHotelParams } from 'src/reselect/searchSelector'
import { useSelector } from 'react-redux'

const PhsLoadPriceRate = (props) => {
    const { messageId, show, delay } = props
    const [visible, setVisible] = useState(show);
    const [redirectPageCallback] = redirectPage();
    const paramsHotel = useSelector(selectSearchHotelParams());

    useEffect(() => {
        if (delay && visible) {
            const timer = setTimeout(() => {
                setVisible(false);
            }, delay);
            return () => clearTimeout(timer);
        }
    }, [delay, visible]);

    useEffect(() => {
        if (messageId === 'Order.Hotel.Login.Loading.Error.Catch') {
            const timer = setTimeout(() => {
                handleGoBack();
            }, 5000);
            return () => clearTimeout(timer);
        }
    }, [messageId]);

    const handleGoBack = () => {
        SessionStorage.remove(LOCAL_STORAGE_KEY.PHS_ORDER_HOTEL);
        const asPath = queryStringExtensions.getComboQueryStringWithHotel('/hotel', paramsHotel?.hotelId, paramsHotel, "");
        redirectPageCallback(asPath)
    };

    const handleContinue = () => {
        setVisible(false);
    };

  return (
    <Modal
      visible={visible}
      onOk={false}
      onCancel={false}
      closable={false}
      footer={null}
    >
      <div className="text-center vpt-form">
          <FormattedMessage
            id={messageId}
            defaultMessage={''}
          />
        <br></br>
        {messageId === 'Order.Hotel.Login.Loading.Error' && (
          <div className="button-group">
            <br></br>
            <Button
              className="g-bg-primary g-brd-primary g-color-white"
              onClick={handleGoBack}
              style={{ marginRight: '10px' }}
            >
              <FormattedMessage id="Order.Hotel.Login.Loading.Error.GoBack" defaultMessage="Go Back" />
            </Button>
            <Button
              className="g-bg-primary g-brd-primary g-color-white"
              onClick={handleContinue}
            >
              <FormattedMessage id="Order.Hotel.Login.Loading.Error.ContinueBooking" defaultMessage="Continue Booking" />
            </Button>
          </div>
        )}
        {messageId === 'Order.Hotel.Login.Loading.Error.Catch' && (
          <div className="button-group">
            <br></br>
            <Button
              className="g-bg-primary g-brd-primary g-color-white"
              onClick={handleGoBack}
              style={{ marginRight: '10px' }}
            >
              <FormattedMessage id="Order.Hotel.Login.Loading.Error.GoBack" defaultMessage="Go Back" />
            </Button>
          </div>
        )}
      </div>
      
    </Modal>
  );
}

export default connectModal ({name: 'phsLoadPriceRate', destroyOnHide: true}) (PhsLoadPriceRate)
